<template>
    <b-card no-body>

        <b-modal :size="calculatedPrice ? 'xl' : 'lg'" id="calculate-prices" title="Fiyat Güncelleme" hide-footer no-close-on-esc no-close-on-backdrop>
            <agreement-calculate-price v-on:calculated="$e => calculatedPrice = $e" :ids="calculatePriceIds"></agreement-calculate-price>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server">
            <template #additional-actions>
                <div class="d-flex justify-content-end">
                    <button class="btn btn-outline-primary" v-on:click="dailyRouteCheckReport">
                        <feather-icon icon="BarChart2Icon" class="mr-50" size="14"></feather-icon>
                        Günlük Fiyat Kontrol Raporu
                    </button>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard,BFormCheckbox } from 'bootstrap-vue'
import { AgreementApi } from '@/api/agreement'
import AgreementCalculatePrice from './AgreementCalculatePrice.vue';

export default {
    components:{
        BCard,
        BFormCheckbox,
        AgreementCalculatePrice
    },
    data(){
        return{
            editing:false,
            loading:false,
            calculatedPrice: false,
            fields:[
                {name:'Sözleşme No',key:'AgreementCode',sortable:true, thClass:'w-15'},
                {name:'Sözleşme Adı',key:'Name',sortable:true, thClass:'w-25',tdClass:'text-nowrap'},
                {name:'Cari Kod',key:'CariCode',sortable:true, thClass:'w-15'},
                {name:'Cari',key:'CariName',sortable:true, thClass:'w-25',tdClass:'text-nowrap'},
                {name:'Sözleşme Baş. Tarihi',key:'StartDate',sortable:true, thClass:'w-10'},
                {name:'Sözleşme Bitiş Tarihi',key:'ExpireDate',sortable:true, thClass:'w-10'},
            ],
            buttons:[
                { text:"Detay Görüntüle",key:"view",icon:"EyeIcon",variant:"secondary",action:this.detail },
                { text:"Oransal Fiyat artışı",key:"price-history",icon:"ActivityIcon",variant:"primary",action:this.priceHistory },
                // { text:"Fiyat Güncelleme",key:"price-calculate",icon:"TrendingUpIcon",variant:"info",action:this.calculatePrices },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            firm:{
                Id:null,
                Name: null,
                AgreementCode:null,
                FirmId:null,
                VehicleTypeId:null,
                AgreementRoutePrices:[]
            },
            calculatePriceIds:[],
            updating:false
        }
    },
    methods:{
        provider(data){
            return AgreementApi.Table(data)
        },
        createNew(){
            this.$router.push({name:'agreement-create'})
        },
        detail(item){
            this.$router.push({name:'agreement-detail',params:{id:item.Id}})
        },
        priceHistory(item){
            this.$router.push({name:'agreement-price-history',params:{id:item.Id}})
        },
        dailyRouteCheckReport(){
            this.$router.push({name:'agreement-daily-route-check-report'})
        },
        calculatePrices(item){
            this.calculatePriceIds = []
            this.calculatePriceIds = [item.Id]
            this.$showModal('calculate-prices')
        }, 
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.CariCode} kodlu cariye ait olan ${item.Name} adlı sözleşmeyi silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    AgreementApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                        
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>
